export enum ArrayConditionOperators {
  CONTAINS = "contains",
  CONTAINS_NOT = "contains-not"
}
